export const Urls = {
    GetDynamicEntityTypes: "ManageEntities/GetDynamicEntityTypes",
    GetDynamicColumnsForEntities: "ManageEntities/GetDynamicColumnsForEntities",
    GetDynamicColumnNamesForEntityType : "ManageEntities/GetDynamicColumnNamesForEntityType",
    GetDynamicPropertiesForEntity: "ManageEntities/GetDynamicPropertiesForEntity",
    SaveDynamicColumnsForEntities: "ManageEntities/SaveDynamicColumnsForEntities",
    SaveDynamicPropertiesForEntity: "ManageEntities/SaveDynamicPropertiesForEntity",
    CloneDynamicColumn: "ManageEntities/CloneDynamicColumn",
};
